<template>
  <div v-if="tree && tree.length" class="columns">
    <el-dropdown
      :hide-on-click="false"
      placement="bottom-start"
      @mousedown.stop
      @click.stop
    >
      <el-button :size="size">
        Колонки
        <el-icon style="margin-left: 10px"><ArrowDown /></el-icon>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu class="columns-dropdown">
          <el-tree
            :data="tree"
            :show-checkbox="true"
            check-on-click-node
            :check-strictly="true"
            :default-expand-all="false"
            :node-key="nodeKey"
            :default-checked-keys="defaultCheckedKeys"
            :default-expanded-keys="defaultExpandedKeys"
            :props="defaultProps"
            empty-text=""
            @check-change="handleCheckChange"
          />
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import _ from "lodash-es";
import {ArrowDown} from "@element-plus/icons-vue";

export default {
  name: "BaseColumns",
  components: {ArrowDown},
  props: {
    "sharedId": {
      type: [Number, String],
      default: null,
    },
    "size": {
      type: String,
      default: "default",
    },
    "customStyle": {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tree: [],
      nodeKey: "id",
      defaultProps: {
        children: "children",
        label: "label",
        disabled: "disabled",
        parentId: "parentId",
      },
      defaultCheckedKeys: [],
      defaultCheckedKeysClone: [],
      defaultExpandedKeys: [],
      columnsValues: null,
      sortedColumns: []
    }
  },
  computed: {
    columns() {
      return _.sortBy(this.$store.getters["Columns/getColumns"], 'id');
    },
    elementId() {
      return this.$store.getters["Linker/getLink"](this.sharedId)
    }
  },
  watch: {
    columns: {
      handler(newVal, oldVal) {
        if (!_.isEqual(newVal, oldVal)) {
          this.setTree();
        }
      },
      deep: true,
      immediate: true
    },
    elementId: {
      handler(val) {
        if(val) {
          this.setTree()
        }
      }
    }
  },
  created() {
    if (this.columns) {
      this.sortedColumns = _.sortBy(this.columns, 'id');
      this.setTree()
    }
  },
  methods: {
    setTree() {
      this.setColumnsValues()
      // let elementId = this.$store.getters["Linker/getLink"](this.sharedId)
      this.sortedColumns = _.sortBy(this.columns, 'id');
      this.tree = this.getTree(this.elementId)
    },
    setColumnsValues() {
      if (this.columnsValues && this.columns.length === 0) {
        this.$store.dispatch("Columns/actionSetColumnValues", this.columnsValues)
        this.columnsValues = null
      }
    },
    getTree(elementId) {
      this.defaultCheckedKeysClone = []
      let columns = this.getChildren(elementId)
      this.defaultCheckedKeys = this.defaultCheckedKeysClone
      return columns.filter(col => col.label)
    },
    getChildren(parentId) {
      let checkedValues = this.$store.getters["Columns/getColumnValues"]
      return _.sortBy(this.$store.getters["Columns/getColumnsByParent"](parentId), 'id')
        .map(item => {
          if (item.defaultValue) {
            this.defaultCheckedKeysClone.push(item.id)
          }
          if (checkedValues[item.id]) {
            this.defaultCheckedKeysClone.push(item.id)
          }

          let obj = {
            id: item.id,
            parentId: item.parentId,
            label: item.label,
            disabled: item.defaultValue === "always",
          }
          let children = this.getChildren(item.id)
          if (children && children.length) {
            obj.children = children
          }
          return obj
        })
    },
    handleCheckChange(data, checked, indeterminate) {
      this.setColumnValue(data, checked || indeterminate)
      if (checked || indeterminate) {
        this.setColumnValueUp(data, true)
      }
    },
    setColumnValue(data, value) {
      if (this.$store.getters["Columns/getColumnValue"](data.id) != value) {
        this.$store.dispatch("Columns/actionSetColumnValue", {id: data.id, value: value})
      }
      if (data.children) {
        data.children.forEach(item => {
          this.setColumnValue(item, value)
        })
      }
    },
    setColumnValueUp(data, value) {
      let item = this.$store.getters["Columns/getColumn"](data.parentId)
      if (item) {
        if (this.$store.getters["Columns/getColumnValue"](data.parentId) !== value) {
          this.$store.dispatch("Columns/actionSetColumnValue", {id: data.parentId, value: value})
        }
        this.setColumnValueUp(item, value)
      }
      this.columnsValues = this.$store.getters["Columns/getColumnValues"]
    }
  },
}
</script>

<style lang="scss" scoped>
.columns {
  display: block;
  &-dropdown {
    max-height: 250px;
    overflow-y: auto;
    padding-right: 15px;
    & :deep(.el-tree-node__content) {
      height: 20px;
      padding: 8px
    }
  }
}

</style>
